module.exports = __webpack_public_path__ + "static/media/rlb.6d10aa3a.png";